var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "profile-wrapper" }, [
    _vm.applied
      ? _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row justify-content-center" }, [
            _c(
              "div",
              {
                staticClass: "col-6 col-xs-12 col-md-6 justify-content-center",
              },
              [_c("ApplySuccess", { attrs: { application: "true" } })],
              1
            ),
          ]),
        ])
      : _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "mobile-only top-bar" },
            [
              _c(
                "nuxt-link",
                { staticClass: "btn btn-default", attrs: { to: "/p-loan" } },
                [_c("i", { staticClass: "fas fa-chevron-left" })]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 profile-content form-content" }, [
              _c(
                "form",
                {
                  class: { loading: _vm.submitting },
                  attrs: {
                    id: "lead-form",
                    action: "#",
                    "data-survey-code": _vm.formId,
                  },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.formSubmit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "profile-panel" },
                    [
                      _c("div", { staticClass: "row application-header" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-6 col-xs-12 no-padding" },
                          [
                            _c("img", {
                              attrs: { src: _vm.logo, alt: _vm.companyName },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-6 col-xs-12 no-padding" },
                          [
                            _c("h3", [_vm._v(_vm._s(_vm.companyName))]),
                            _vm._v(" "),
                            _c("h4", [
                              _vm._v(
                                _vm._s(_vm.t("application.personal_form"))
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("CommonFields", {
                        attrs: {
                          companyId: _vm.companyId,
                          companyName: _vm.companyName,
                          from: _vm.from,
                          productId: _vm.productId,
                          vendorEmail: _vm.vendorEmail,
                          vendorMobile: _vm.vendorMobile,
                          productType: "loan",
                          asCompany: true,
                        },
                      }),
                      _vm._v(" "),
                      _vm.isShortForm
                        ? _c("StepShort", {
                            attrs: {
                              verifyMobile: _vm.survey.verifyMobile || false,
                            },
                          })
                        : _c(
                            "section",
                            [
                              _c("Step1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.currentStep === 1,
                                    expression: "currentStep === 1",
                                  },
                                ],
                                ref: "step1",
                              }),
                              _vm._v(" "),
                              _c("Step2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.currentStep === 2,
                                    expression: "currentStep === 2",
                                  },
                                ],
                                ref: "step2",
                              }),
                              _vm._v(" "),
                              _c("Step3", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.currentStep >= 3 &&
                                      _vm.currentStep < _vm.maxStep - 1,
                                    expression:
                                      "currentStep >= 3 && currentStep < maxStep - 1",
                                  },
                                ],
                                ref: "step3",
                                attrs: { step: _vm.currentStep - 2 },
                              }),
                              _vm._v(" "),
                              _c("Step4", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.currentStep === _vm.maxStep - 1,
                                    expression: "currentStep === maxStep - 1",
                                  },
                                ],
                                ref: "step4",
                              }),
                              _vm._v(" "),
                              _c("Step5", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.currentStep === _vm.maxStep,
                                    expression: "currentStep === maxStep",
                                  },
                                ],
                                ref: "step5",
                                attrs: {
                                  checkTu: _vm.checkTu,
                                  hkid: _vm.hkid,
                                  companyName: _vm.companyName,
                                  verifyEmail: _vm.survey.verifyEmail || false,
                                  verifyMobile:
                                    _vm.survey.verifyMobile || false,
                                },
                              }),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row botton-bar" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _vm.currentStep > 1
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-white btn-md btn-default",
                              attrs: { type: "button" },
                              on: { click: _vm.prevStep },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.t("common.prev_step")) +
                                  "\n              "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary btn-md",
                          attrs: { type: "button" },
                          on: { click: _vm.nextStep },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.currentStep >= _vm.maxStep
                                  ? _vm.t("filter.done")
                                  : _vm.t("common.next_step")
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }